import _ from 'underscore'
import $ from 'jquery'
import {isIE8, calculateTooltipOffset} from '../../atBrowserUtils'
import {trim, isEmailValid} from '../../atUtils'
import messageResource from '../../messageResource'

function InviteSeveralUsersRow(){}

InviteSeveralUsersRow.prototype = _.create(Object.prototype, {

    EMPTY_FIRST_NAME_ERROR: "emptyFirstNameError",
    EMPTY_LAST_NAME_ERROR: "emptyLastNameError",
    EMPTY_EMAIL_ERROR: "emptyEmailError",
    INVALID_EMAIL_ERROR: "invalidEmailError",

    init: function(rowNumber, specialRowClasses, validationCallback, changesCallback, errorTooltip)
    {
        this.rowNumber = rowNumber;
        this.specialRowClasses = specialRowClasses || "";
        this.validationCallback = validationCallback;
        this.changesCallback = changesCallback;
        this.errorTooltip = errorTooltip;
        this.isIE8 = isIE8();

        this.errors = {};
        this.firstNameFieldEmpty = true;
        this.lastNameFieldEmpty = true;
        this.emailFieldEmpty = true;

        this.$row = $('<tr>');

        if (this.specialRowClasses)
        {
            this.$row.addClass(this.specialRowClasses);
        }

        var self = this;
        var errorTextsMap = {};

        this.$icon = $('<div>');
        this._addTdToRow(this.$icon, "rowIcon");

        this.$firstName = this._createInput("First Name", 32, "firstNameCell");
        this._addChangeCallbackToInputField(this.$firstName, function() { self.validateFirstName(true); });
        errorTextsMap[InviteSeveralUsersRow.prototype.EMPTY_FIRST_NAME_ERROR] = messageResource.getMessage("user.add_edit.error.first_name_empty");
        this._addErrorTooltipCallbacks(this.$firstName, errorTextsMap);
        this._addTdToRow(this.$firstName);

        this.$lastName = this._createInput("Last Name", 32, "lastNameCell");
        this._addChangeCallbackToInputField(this.$lastName, function() { self.validateLastName(true); });
        errorTextsMap = {};
        errorTextsMap[InviteSeveralUsersRow.prototype.EMPTY_LAST_NAME_ERROR] = messageResource.getMessage("user.add_edit.error.last_name_empty");
        this._addErrorTooltipCallbacks(this.$lastName, errorTextsMap);
        this._addTdToRow(this.$lastName);

        this.$email = this._createInput("Email", 191, "emailCell");
        this._addChangeCallbackToInputField(this.$email,
                                            function() { self.validateEmail(true, true); },
                                            function() { self.onTextFieldChange(_.bind(self.validateEmail, self, true, false)) });
        errorTextsMap = {};
        errorTextsMap[InviteSeveralUsersRow.prototype.EMPTY_EMAIL_ERROR] = messageResource.getMessage("user.add_edit.error.email_empty");
        errorTextsMap[InviteSeveralUsersRow.prototype.INVALID_EMAIL_ERROR] = messageResource.getMessage("user.add_edit.error.email_invalid");
        this._addErrorTooltipCallbacks(this.$email, errorTextsMap);
        this._addTdToRow(this.$email);

        return this;
    },

    _addErrorTooltipCallbacks: function($element, errorTextsMap)
    {
        var self = this;
        $element.hover(function()
                       {
                           for (var p in errorTextsMap)
                           {
                               if (self.errors[p])
                               {
                                   self.errorTooltip.updateUIAndShow({errorText: errorTextsMap[p]});
                                   break;
                               }
                           }
                       },
                       function()
                       {
                           self.errorTooltip.hide();
                       });
        $element.mousemove(function(event)
                           {
                               self.errorTooltip.move(calculateTooltipOffset(self.errorTooltip, event));
                           });
    },

    onTextFieldChange: function(validator)
    {
        validator();
        if (this.hasNoValues())
        {
            this.errors = {};
        }
        this.updateUI();
        if (this.isIE8)
        {
            var sibling = this.$row.next();
            if (sibling.length > 0)
            {
                sibling.addClass("ie8-fix").removeClass("ie8-fix");
            }
        }
    },

    onTextFieldChangeWithValidationAndChangesCallbacks: function(validator)
    {
        this.onTextFieldChange(validator);
        if (this.validationCallback)
        {
            this.validationCallback();
        }
        if (this.changesCallback)
        {
            this.changesCallback();
        }
    },

    _addChangeCallbackToInputField: function($field, validator, onBlurCustomCallback)
    {
        $field.valueChanged(_.bind(this.onTextFieldChangeWithValidationAndChangesCallbacks, this, validator));
        $field.blur(onBlurCustomCallback ? onBlurCustomCallback : _.bind(this.onTextFieldChange, this, validator));
    },

    _addTdToRow: function($tdContent, classname)
    {
        var $td = $('<td>');
        if (classname)
        {
            $td.addClass(classname);
        }
        $td.append($tdContent);
        this.$row.append($td);
    },

    getElement: function()
    {
        return this.$row;
    },

    getUserFields: function()
    {
        return {
            rowNumber: this.rowNumber,
            firstName: this.getFirstName(),
            lastName: this.getLastName(),
            email: this.getEmail()
        }
    },

    getFirstName: function()
    {
        return trim(this.$firstName.pVal());
    },

    getLastName: function()
    {
        return trim(this.$lastName.pVal());
    },

    getEmail: function()
    {
        return trim(this.$email.pVal());
    },

    _createInput: function(placeholder, maxlength, classname)
    {
        var $input = $('<input type="text" placeholder="' + placeholder + '" maxlength="' + maxlength + '" class="' + "inputFieldWithPlaceholder " + classname + '">');
        $input.placeholder();
        return $input;
    },

    validate: function()
    {
        if (this.hasNoValues() && !this.hasErrors())
        {
            return true;
        }
        this.validateFirstName();
        this.validateLastName();
        this.validateEmail();
        return !this.hasErrors();
    },

    validateFirstName: function(onlyRemoveEmptyError)
    {
        this.firstNameFieldEmpty = this.getFirstName().length == 0;
        this._checkInvalid(this.firstNameFieldEmpty, InviteSeveralUsersRow.prototype.EMPTY_FIRST_NAME_ERROR, onlyRemoveEmptyError);
    },

    validateLastName: function(onlyRemoveEmptyError)
    {
        this.lastNameFieldEmpty = this.getLastName().length == 0;
        this._checkInvalid(this.lastNameFieldEmpty, InviteSeveralUsersRow.prototype.EMPTY_LAST_NAME_ERROR, onlyRemoveEmptyError);
    },

    validateEmail: function(onlyRemoveEmptyError, onlyRemoveInvalidError)
    {
        var email = this.getEmail();
        this.emailFieldEmpty = email.length == 0;
        this.errors[InviteSeveralUsersRow.prototype.EMPTY_EMAIL_ERROR] = this.emailFieldEmpty && !onlyRemoveEmptyError;
        this._checkInvalid(this.emailFieldEmpty ? false : !isEmailValid(email), InviteSeveralUsersRow.prototype.INVALID_EMAIL_ERROR, onlyRemoveInvalidError);
    },

    _checkInvalid: function(fieldIsInvalid, errorCode, onlyRemoveError)
    {
        if (fieldIsInvalid)
        {
            if (!onlyRemoveError)
            {
                this.errors[errorCode] = true;
            }
        }
        else
        {
            this.errors[errorCode] = false;
        }
    },

    updateUI: function()
    {
        var classes = [];
        for (var p in this.errors)
        {
            if (this.errors[p])
            {
                classes.push(p);
            }
        }
        this.$row[0].className = this.specialRowClasses + " " + classes.join(" ");
        this.$icon.toggleClass("active", !(this.firstNameFieldEmpty || this.lastNameFieldEmpty || this.emailFieldEmpty || this.hasErrors()));
    },

    hasErrors: function()
    {
        for (var p in this.errors)
        {
            if (this.errors[p])
            {
                return true;
            }
        }
        return false;
    },

    hasNoValues: function()
    {
        return this.firstNameFieldEmpty && this.lastNameFieldEmpty && this.emailFieldEmpty;
    },

    addServerErrors: function(errors)
    {
        var self = this;
        _.each(errors, function(error)
        {
            if (error == "com.actimind.common.services.UserEmailInvalidException")
            {
                self.errors[InviteSeveralUsersRow.prototype.INVALID_EMAIL_ERROR] = true;
            }
        });
    },

    setFocus: function()
    {
        this.$firstName.focus();
    },

    setSpecialRowClasses: function(specialRowClasses)
    {
        this.specialRowClasses = specialRowClasses;
    }
});

export default InviteSeveralUsersRow



// WEBPACK FOOTER //
// ./web/js/administration/userManagement/InviteSeveralUsersRow.js